import { App } from "antd";

export const useAppFeedback = () => App.useApp();
